import { render, staticRenderFns } from "./SettingsAddNewAttachmentType.vue?vue&type=template&id=4292c0fc"
import script from "./SettingsAddNewAttachmentType.vue?vue&type=script&lang=js"
export * from "./SettingsAddNewAttachmentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports